@use '../../../assets/styles/theme';

.standard {
  font-size: 16px;
  color: black;
}
.hoverable {
  cursor: pointer;
}
.inline {
  display: inline;
}
.meta {
  color: theme.$meta;
}
.bold {
  font-weight: bold;
}
.thin {
  font-weight: 300 !important;
}
.error {
  color: rgba(232, 28, 0, 1);
}
.secondary {
  color: theme.$orange-500;
}
